export const FETCH_SYNC_WITH_REVIO_UPDATE_STATUS = 'FETCH_SYNC_WITH_REVIO_UPDATE_STATUS'
